import { render, staticRenderFns } from "./DiseaseTab.vue?vue&type=template&id=2f764997&scoped=true"
import script from "./DiseaseTab.vue?vue&type=script&lang=js"
export * from "./DiseaseTab.vue?vue&type=script&lang=js"
import style0 from "./DiseaseTab.vue?vue&type=style&index=0&id=2f764997&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f764997",
  null
  
)

export default component.exports